/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import config from '@config';
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
/* Styles */
import NotEnoughSt from '@moms/styleData/NotEnoughSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const MainLayout = ({ region, lang, sectionContent }) => {
  if (!sectionContent || sectionContent.length < 5) return null;

  return (
    <Flex
      px={{ base: '1rem', md: '0' }}
      maxW={'1090px'}
      gap={{ base: '6rem', md: '5rem' }}
      width={{ md: '90%', xl: '100%' }}
      mx={'auto'}
      flexDir={{ base: 'column', md: 'row' }}
    >
      {/* Left flex */}
      <LeftBox region={region} lang={lang} sectionContent={sectionContent} />

      {/* right flex */}
      <RightBox region={region} lang={lang} sectionContent={sectionContent} />
    </Flex>
  );
};

const LeftBox = ({ region, lang, sectionContent }) => {
  if (!sectionContent || sectionContent.length < 5) return null;

  return (
    <Flex maxW="485px" flexDir={'column'}>
      <Box key={sectionContent[0].id}>
        <StructuredTextParser
          {...NotEnoughSt?.[lang]?.title}
          str={render(sectionContent[0].body.value)}
        />
      </Box>

      <Box
        key={sectionContent[1].id}
        mt={{ base: '3rem', md: '2rem' }}
        pr={{ base: '1rem', md: '0' }}
      >
        <StructuredTextParser
          {...NotEnoughSt?.[lang]?.titleSubtext}
          str={render(sectionContent[1].body.value)}
        />
      </Box>
      <Box
        key={sectionContent[2].id}
        textTransform={'uppercase'}
        mt={{ base: '3rem', md: '2rem' }}
        pr={{ base: '5rem', md: '0' }}
      >
        <StructuredTextParser
          {...NotEnoughSt?.[lang]?.text3}
          str={render(sectionContent[2].body.value)}
        />
      </Box>
      <Box key={sectionContent[3].id} mt={{ base: '1rem', md: '-.5rem' }}>
        <StructuredTextParser
          {...NotEnoughSt?.[lang]?.item}
          str={render(sectionContent[3].body.value)}
        />
      </Box>
    </Flex>
  );
};
const RightBox = ({ region, lang, sectionContent }) => {
  if (!sectionContent || sectionContent.length < 5) return null;

  return (
    <Flex
      key={sectionContent[4].id}
      flexDir={'column'}
      gap={{ base: '.5rem' }}
      alignSelf={{ md: 'flex-end' }}
    >
      <Text {...NotEnoughSt?.[lang]?.item1}>{sectionContent[4].titleText}</Text>
      <Text {...NotEnoughSt?.[lang]?.item2}>
        {sectionContent[4].titleSubtext}
      </Text>
      <Text {...NotEnoughSt?.[lang]?.item3}>
        {sectionContent[4].additionalTextLine}
      </Text>
    </Flex>
  );
};

const NotEnough = ({ region, lang, sectionContent }) => {
  if (!sectionContent || sectionContent.length < 5) return null;

  return (
    <Box
      // my={{ base: '2rem', md: '4rem' }}
      pt={{ base: '2rem', md: '8rem' }}
      pb={{ base: '10rem', md: '8rem' }}
      bgImage={`url('${config.imgPath}/d/46272/1739257635-31-2.png')`}
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
    >
      <MainLayout region={region} lang={lang} sectionContent={sectionContent} />
    </Box>
  );
};

export default NotEnough;
